module.exports = __webpack_public_path__ + "static/img/qiRobot.d91c917.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qiRobot.png
// module id = uzD4
// module chunks = 1